<template>
  <div class="ctt-module">
    <img :src="moduleData.img_url" alt="">
    <div class="btn" v-if="moduleData.is_click" @click="showModal"></div>
  </div>
</template>
<script>
export default {
  props: {
    moduleData: {
      type: Object
    }
  },
  methods: {
    showModal() {
      this.$emit('consult');
    }
  }
}
</script>

<style lang="less" scoped>
.ctt-module {
  position: relative;
}

.btn {
  width: 4.7rem;
  height: 0.92rem;
  // background: pink;
  position: absolute;
  left: 50%;
  bottom: 1rem;
  transform: translateX(-50%);
  cursor: pointer;
}

.mobile  .btn {
    width: 6.1rem;
    height: 1.2rem;

  }
</style>



// WEBPACK FOOTER //
// src/components/modules/content-base.vue